module.exports = __webpack_public_path__ + "addfiles.93ef7f01.svg";